import { Box, Button, Typography, CircularProgress, Backdrop } from "@mui/material"
import { OrderModel } from "../../models/order";
import { numberFormat } from "../../utils/nunberFormat";
import { calculateOrderProductUnitByCarts } from "../../utils/calculateOrderProductUnitByCarts";
import { SECONDARY_COLOR } from "../../constants/colors";
import { QRCodeCanvas } from 'qrcode.react';
import useRiderScanToConfirm from "./controller/riderScanToConfirm";
import { useTranslation } from "react-i18next";
import PaymentMethodText from "../../components/PaymentMethodText";
import { PaymentMethodEnum } from "../../enums/paymentMethod";

interface Props {
    selectedData: OrderModel,
    onRefetchData: () => Promise<void>;
    onClose: VoidFunction
}

const RiderScanToConfirm = ({ selectedData, onRefetchData, onClose }: Props) => {
    const controller = useRiderScanToConfirm({
        onClose,
        onRefetchData
    });
    const { t } = useTranslation("global")
    return <Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{
                display: 'flex', justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                maxWidth: 700,
                paddingTop: 4,
                paddingLeft: 2,
                paddingRight: 2,
                paddingBottom: 4,
                flexDirection: 'column',
                borderRadius: "16px",
                background: "var(--background-light-paper, #FFF)",
                boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
            }}>
                <QRCodeCanvas value={selectedData?.id} size={135} />
                <Typography fontSize="24px" sx={{ mt: 2 }}>{t("order_page.Rider scan to confirm")}!</Typography>
                <Box mt={5} sx={{ width: '100%', maxWidth: 350 }}>
                    <Typography sx={{ lineHeight: 2 }} fontSize="20px" color="666">{t("order_page.Order detail")}</Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Order ID")} : <span style={{ fontWeight: 'bold' }}>{selectedData?.orderNo}</span></Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Order number")} : <span style={{ fontWeight: 'bold' }}>{selectedData?.orderNumber}</span></Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.units")} : <span style={{ fontWeight: 'bold', backgroundColor: SECONDARY_COLOR, borderRadius: '8px', padding: "5px 10px 5px 10px", color: 'white', minWidth: "87px" }}>{numberFormat(calculateOrderProductUnitByCarts(selectedData?.carts))}</span></Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Total")} : <span style={{ fontWeight: 'bold' }}>{numberFormat(selectedData?.totoalWithDeliveryFee)}</span> {t("Kip")}</Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Payment method")} : <PaymentMethodText paymentMethod={selectedData?.paymentMethod as PaymentMethodEnum}/></Typography>
                </Box>
                <Button onClick={controller.handleClickDoneButton} variant="contained" color="secondary" sx={{ textTransform: 'none', color: 'white', mt: 2 }}>{t("Done")}</Button>
            </Box>
        </Box>

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={controller.loading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </Box>
}
export default RiderScanToConfirm;